import React from "react";
import PropTypes from "prop-types";
import { Markdown, Body, spacing, palette } from "@conserveit/blocks";
import styled from "styled-components";

const StyledAlert = styled.div`
  padding: 10px !important;
  margin-bottom: ${spacing.loose};
  &.alert-error {
    background-color: ${palette.red3};
    color: ${palette.red7};
  }
  &.alert-success {
    background-color: ${palette.green3};
    color: ${palette.green7};
  }
  &.alert-warning {
    background-color: ${palette.yellow3};
    color: ${palette.yellow7};
  }
`;

const MsgAlert = ({ type, message }) => {
  if (!message) return null;
  return (
    <StyledAlert className={`alert-${type}`}>
      <Body as="div">
        <Markdown
          source={
            (typeof message === "object" ? JSON.stringify(message) : message) ||
            ""
          }
        />
      </Body>
    </StyledAlert>
  );
};

MsgAlert.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
};

MsgAlert.defaultProps = {
  message: "",
};

export default MsgAlert;
